import React from 'react';
import styled from 'styled-components';
import { testId } from '@lojinha/helpers';
import { Box } from '../Box';
import { Stack } from '../Stack';
import { ArrowRight } from '../Icons/arrow-right';
const Component = styled.div `
  ${({ theme }) => `
    border-radius: ${theme.space.x4};
    height: ${theme.space.x32};
    width: ${theme.space.x32};
    padding: ${theme.space.x8};
    background-color: ${theme.colors.white};
  `}
  overflow: hidden;

  &:hover > div {
    transform: translateX(0);
    transition: transform 300ms ease-out;

    .first-icon {
      opacity: 1;
      transition: opacity 300ms ease-out;
    }
  }
`;
const IconContainer = styled(Stack) `
  width: ${({ theme }) => theme.space.x64};
  transform: translateX(-32px);
  transition: transform 300ms ease-out;

  .first-icon {
    opacity: 0;
    transition: opacity 300ms ease-out;
  }
`;
export const ArrowButton = ({ color }) => (React.createElement(Box, { display: "flex", htmlAttrs: { style: { alignSelf: 'flex-start' } }, ...testId('arrow-button') },
    React.createElement(Component, null,
        React.createElement(IconContainer, { layout: "horizontal" },
            React.createElement("div", { className: "first-icon" },
                React.createElement(ArrowRight, { color: color })),
            React.createElement("div", null,
                React.createElement(ArrowRight, { color: color }))))));
ArrowButton.defaultProps = {
    color: undefined,
};
//# sourceMappingURL=index.js.map